export const FETCH_ORGANIZATION = 'fetch-organization';
export const FETCH_ORGANIZATION_BY_NAME = 'fetch-organization-by-name';
